
      import BringFront from './bring-front.vue'
      import type { App, Plugin } from 'vue'

      export const BringFrontPlugin: Plugin = {
        install(app: App) {
          app.component('BringFront', BringFront)
        },
      }
      export { BringFront }
      